<template>
    <div class="DocumentMiscOptions">
        
        <b-modal ref="component-modal" title="Misc. Document Options" size="md"  hide-footer >
            <b-container>
                <p class="red">NOTE: Moving a Document to DRAFT status will remove all signatures on the document.</p>
                <b-button v-if="CanMoveDocumentToAuthorsDrafts" size="lg" class="form-control vert-space" variant="primary" @click="MoveDocumentToCoworkersDrafts(AuthorEmployeeId)">
                    MOVE TO AUTHOR'S DRAFTS
                </b-button>
                <b-button v-if="CanMoveDocumentToMyDrafts" size="lg" class="form-control vert-space" variant="primary" @click="MoveDocumentToCoworkersDrafts(EmployeeId)">
                    MOVE TO MY DRAFTS
                </b-button>
                <b-dropdown v-if="CanMoveDocumentToCoworkersDrafts" size="lg" variant="primary" class="vert-space scrollable-dropdown" text="MOVE TO COWORKER'S DRAFTS" block>
                    <b-dropdown-item v-for="employee in SubProgramEmployeeOptions" @click="MoveDocumentToCoworkersDrafts(employee.value)">
                        {{ employee.text }}
                    </b-dropdown-item>
                </b-dropdown>
                <!--<v-select required :options="SubProgramEmployeeOptions" label="text" :reduce="option => option.value">
                </v-select>-->

                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="Cancel()">
                            CANCEL
                        </b-button>

                    </div>
                </b-row>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faPencilRuler } from '@fortawesome/free-solid-svg-icons';
    //library.add(faPencilRuler);
    import { EventBus } from '../../../services/event-bus.js';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        props: [
            
        ],
        data: function () {
            return {
                ChartId: "",
                DocumentId: "",
                AuthorEmployeeId: "",
                CanMoveDocumentToMyDrafts: false,
                CanMoveDocumentToAuthorsDrafts: false,
                CanMoveDocumentToCoworkersDrafts: false,
                SubProgramEmployeeOptions: []
            }
        },
        methods: {
            ShowModal: function (chartID, authorEmployeeId, documentID, canMoveDocumentToMyDrafts, canMoveDocumentToAuthorsDrafts, canMoveDocumentToCoworkersDrafts) {
                this.ChartId = chartID,
                this.AuthorEmployeeId = authorEmployeeId;
                this.DocumentId = documentID;
                this.CanMoveDocumentToMyDrafts = canMoveDocumentToMyDrafts;
                this.CanMoveDocumentToAuthorsDrafts = canMoveDocumentToAuthorsDrafts;
                this.CanMoveDocumentToCoworkersDrafts = canMoveDocumentToCoworkersDrafts;
                this.GetCoworkerEmployeeOptions();

                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            MoveDocumentToCoworkersDrafts(employeeID) {
                 this.$MasterAPI.ExecuteRequest("POST", "Core/Documents/MoveToEmployeeDrafts",{ DocumentID: this.DocumentId, EmployeeID: employeeID }, this.MoveDocumentToCoworkersDraftsSuccess, () => { }, true);
            },
            MoveDocumentToCoworkersDraftsSuccess(response) {
                EventBus.$emit('case-file-updated', this.ChartId);
                EventBus.$emit('drafts-updated', this.ChartId);
                this.$refs['component-modal'].hide();
            },
            GetCoworkerEmployeeOptions() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/User/GetCoworkerEmployeeOptions", {}, this.GetCoworkerEmployeeOptionsSuccess, () => { }, true);
            },
            GetCoworkerEmployeeOptionsSuccess(response) {
                this.SubProgramEmployeeOptions = response.data.data;
            }

        },
        components: {
            vSelect
        },
        computed: {
            EmployeeId: function () {
                return this.$store.state.User.PrivateProfile.EmployeeID;
            },
        },
        mounted: function () {
            
        }
    }
</script>

<style scoped>
    .vert-space {
        margin-top: 10px;
        margin-bottom: 10px;
    }
</style>